function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    // console.log('Variant Radios');
    
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);







// Modificación de las Tallas:

if($("#generoTallaje").val() == "NINOS") { 
  changeNameTallas("K");
  changeNameTallas("J");
}

// Input hidden Hombre:
if($("#generoTallaje").val() == "HOMBRE"){
  let countItemEstructura = 0;
  
  $(".input-talla").each(function(i){    
    if($(this).val().includes("M")){
      countItemEstructura += 1;
    }
  })
  if(countItemEstructura == 0){
    $(".menu-mujer").attr("style", "display: none");
    $(".menu-hombre").attr("style", "display: block");
  }
  changeNameTallas("H");
  
  $(".menu-hombre").attr("style", "box-shadow: inset 0 -2px 0 0 #000;");
  //let splitValueActive = options2[0].split("-");
  //document.getElementById("valueTalla").innerHTML = splitValueActive[0].replace("H","");
}else if($("#generoTallaje").val() == "MUJER"){

  let countItemEstructura = 0;
  $(".input-talla").each(function(i){
    if($(this).val().charAt(0) == "H"){
      countItemEstructura += 1;
    }
  })
  

  if(countItemEstructura == 0){
    $(".menu-hombre").attr("style", "display: none");
    $(".menu-mujer").attr("style", "display: block");
  }
  changeNameTallas("M");
  $(".menu-mujer").attr("style", "box-shadow: inset 0 -2px 0 0 #000;");
  //let splitValueActive = options2[0].split("-");
  //document.getElementById("valueTalla").innerHTML = splitValueActive[1].replace("M","");
}else{ //Unisex
  $(".input-talla").each(function(i){
    if($(this).val().charAt(0) == "H"){
      // Muestra el menú de Hombre y Mujer: 
      $(".menu-mujer-unisex").attr("style", "display: block;");
      $(".menu-hombre-unisex").attr("style", "display: block;  box-shadow: inset 0 -2px 0 0 #000;");

      $(".menu-hombre-unisex").attr("data-selected-gender", "hombre");
      $(".menu-mujer-unisex").attr("data-selected-gender", "");


      $(".input-talla").each(function(i){
        
        let arrayValues;
        if($(this).val().search("/") != -1){ //Si la tiene.
          arrayValues = $(this).val().toUpperCase().split("/");
        }else{
          arrayValues = $(this).val().toUpperCase().split("-");
        }

        for (let index = 0; index < arrayValues.length; index++) {
          let value = arrayValues[index];
          if(value.charAt(0) == "H"){
            $(this).attr("data-seleccionada", arrayValues[index]);
            $(".item-talla").eq(i).text(arrayValues[index].replace("H", ""));
          }
          
        }
      })
      sortElementSelect('.content-tallas');
      
    }else if($(this).val().charAt(0) == "M"){
      $(".input-talla").each(function(i){

        let arrayValues;
        if($(this).val().search("/") != -1){ //Si la tiene.
          arrayValues = $(this).val().toUpperCase().split("/");
        }else{
          arrayValues = $(this).val().toUpperCase().split("-");
        }

        for (let index = 0; index < arrayValues.length; index++) {
          let value = arrayValues[index];
          if(value.charAt(0) == "M"){
            $(this).attr("data-seleccionada", arrayValues[index]);
            $(".item-talla").eq(i).text(arrayValues[index].replace("M", ""));
          }
        }
      })
      sortElementSelect('.content-tallas');
    }else{
      $(this).attr("data-seleccionada", $(this).val());
      changeNameTallas("");
    }
  })
}

$(".menu-hombre").click(function(){
  changeNameTallas("H");
  $(".menu-hombre").attr("style", "box-shadow: inset 0 -2px 0 0 #000;");
  $(".menu-mujer").attr("style", "box-shadow: none;");
})

$(".menu-mujer").click(function(){
  changeNameTallas("M");
  $(".menu-mujer").attr("style", "box-shadow: inset 0 -2px 0 0 #000;");
  $(".menu-hombre").attr("style", "box-shadow: none;");
})

$(".menu-hombre-unisex").click(function(){
  changeNameTallas("H");
  $(".input-talla").each(function(e, i){
    if($(this).val().indexOf("H") == -1){
      $(this).parent().attr("style", "display: none");
    }else{
      $(this).parent().attr("style", "display: block");       
     
    }
  })
  $(".menu-hombre-unisex").attr("style", "display: block; box-shadow: inset 0 -2px 0 0 #000;"); 
  $(".menu-mujer-unisex").attr("style", "display: block; box-shadow: none;");

  $(".menu-hombre-unisex").attr("data-selected-gender", "hombre");
  $(".menu-mujer-unisex").attr("data-selected-gender", "");

  let man_action = document.getElementById('mhu');
  let selected_gender;

  let size_type = localStorage.getItem('size_type');

  if(!size_type){
    localStorage.setItem('size_type', 'us');
  }

  if(man_action.dataset.selectedGender === 'hombre') {
    selected_gender = 'hombre';
    // console.log('Tiene seleccionado el género hombre.');
  }else{
    selected_gender = 'mujer';
    // console.log('Tiene seleccionado el género mujer.');
  }

  if(size_type){
    let sizes_values = document.querySelectorAll('.container-info-tallas .content-tallas .container-item-talla .item-talla');
    if(size_type === 'eu'){
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
    } else if (size_type === 'us') {
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
    }
  }

})


// let arreglo_tallas_reales = [];

$(".menu-mujer-unisex").click(function(){
  changeNameTallas("M");
  $(".input-talla").each(function(e, i){
    if($(this).val().indexOf("M") == -1){
      $(this).parent().attr("style", "display: none");
    }else{
      $(this).parent().attr("style", "display: block");
      
    }
  })
  $(".menu-mujer-unisex").attr("style", "display: block; box-shadow: inset 0 -2px 0 0 #000;");
  $(".menu-hombre-unisex").attr("style", "display: block; box-shadow: none;");

  $(".menu-mujer-unisex").attr("data-selected-gender", "mujer");
  $(".menu-hombre-unisex").attr("data-selected-gender", "");

  let man_action = document.getElementById('mhu');
  let selected_gender;
  let size_type = localStorage.getItem('size_type');

  if(!size_type){
    localStorage.setItem('size_type', 'us');
  }

  if(man_action.dataset.selectedGender === 'hombre') {
    selected_gender = 'hombre';
    // console.log('Tiene seleccionado el género hombre.');
  }else{
    selected_gender = 'mujer';
    // console.log('Tiene seleccionado el género mujer.');
  }

  if(size_type){
    let sizes_values = document.querySelectorAll('.container-info-tallas .content-tallas .container-item-talla .item-talla');
    if(size_type === 'eu'){
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
    } else if (size_type === 'us') {
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
    }
  }
})

// Tallas del carrito:

$(".value-variant-talla").each(function(i){

  let arrayValues; 
  // let arrayValues = $(this).attr("data-val-talla").trim().split("-");  
  if($(this).attr("data-val-talla").search("/") != -1){ //Si la tiene.
    arrayValues = $(this).attr("data-val-talla").trim().toUpperCase().split("/");     
  }else{
    arrayValues = $(this).attr("data-val-talla").trim().toUpperCase().split("-");  
  }
  
  for (let index = 0; index < arrayValues.length; index++) {
    let value = arrayValues[index];     
    if(value.charAt(0) == $(this).attr("data-genero")){
      $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
    }else if ($(this).attr("data-genero") == "unisex"){
      if($(this).parent().parent().find(".value-properties-product").find("dd").text().charAt(0) == "H"){
        $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
      }else{
        $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
      }
    }else{
      $(this).text($(this).parent().parent().find(".value-properties-product").length > 0 ? $(this).parent().parent().find(".value-properties-product").find("dd").text() : $(this).attr("data-val-talla"));
    }
  }
})

/*Cuando vienen sin el prefijo de sexo H o M*/
$(".input-talla").click(function(){
  if($(this).val().indexOf("M") == -1 && $(this).val().indexOf("H") == -1){
    $(this).attr("data-seleccionada", $(this).val());  
  }else{
    if($(".menu-hombre-unisex").length > 0){
      if($(".menu-hombre-unisex").attr("style").indexOf("box-shadow: inset 0 -2px 0 0 #000;") != -1){
        $(this).attr("data-seleccionada", $(this).val().split("-")[0]);  
      }else{
        $(this).attr("data-seleccionada", $(this).val().split("-")[1]);
      }
    }else{
      $(this).attr("data-seleccionada", $(this).val().split("-")[0]);
    }
    
    if($("#generoTallaje").val() == "MUJER"){
      if($(".menu-hombre").length > 0 && $(".menu-hombre").attr("style") != undefined){
        if($(".menu-hombre").attr("style").indexOf("box-shadow: inset 0 -2px 0 0 #000;") != -1){
          $(this).attr("data-seleccionada", $(this).val().split("-")[0]);  
        }else{
          $(this).attr("data-seleccionada", $(this).val().split("-")[1]);  
        }
      }else if($(".menu-mujer").length > 0 && $(".menu-mujer").attr("style") != undefined){
        if($(".menu-mujer").attr("style").indexOf("box-shadow: inset 0 -2px 0 0 #000;") != -1){
          $(this).attr("data-seleccionada", $(this).val().split("-")[1]);
        }else{
          $(this).attr("data-seleccionada", $(this).val().split("-")[0]);
        }
      }
    }
    
    if($("#generoTallaje").val() == "HOMBRE"){
      if($(".menu-hombre").length > 0 && $(".menu-hombre").attr("style") != undefined){
        if($(".menu-hombre").attr("style").indexOf("box-shadow: inset 0 -2px 0 0 #000;") != -1){
          $(this).attr("data-seleccionada", $(this).val().split("-")[0]);  
        }else{
          $(this).attr("data-seleccionada", $(this).val().split("-")[1]);  
        }
      }else if($(".menu-mujer").length > 0 && $(".menu-mujer").attr("style") != undefined){
        if($(".menu-mujer").attr("style").indexOf("box-shadow: inset 0 -2px 0 0 #000;") != -1){
          $(this).attr("data-seleccionada", $(this).val().split("-")[1]);
        }else{
          $(this).attr("data-seleccionada", $(this).val().split("-")[0]);
        }
      }
    }
  }
});

function changeNameTallas(type){
  $(".input-talla").each(function(i){

    let arrayValues;
    if($(this).val().search("/") != -1){ //Si la tiene.
      arrayValues = $(this).val().trim().toUpperCase().split("/");
    }else{
      arrayValues = $(this).val().trim().toUpperCase().split("-");
    }
    for (let index = 0; index < arrayValues.length; index++) {
      let value = arrayValues[index];
      if(value.charAt(0) == type){
        $(this).attr("data-seleccionada", arrayValues[index]);
        $(".item-talla").eq(i).text(arrayValues[index].replace(type, ""));
      }
    }
    // $(this).attr("data-seleccionada", "");
  });

  sortElementSelect('.content-tallas');
}

function sortElementSelect(idList){
	var $myList = $(idList);
  	
    var $item = $myList.children('.container-item-talla');

    var sortList = Array.prototype.sort.bind($item);
  
  	
    sortList(function ( a, b ) {		
        // Cache inner content from the first element (a) and the next sibling (b)
        var aText = a.children[1].innerText;
        var bText = b.children[1].innerText;

        // Returning -1 will place element `a` before element `b`
        if ( aText < bText ) {
            return -1;
        }

        // Returning 1 will do the opposite
        if ( aText > bText ) {
            return 1;
        }

        // Returning 0 leaves them as-is
        return 0;
    });
      
    $myList.append($item);
}

/** Fin de Tallas **/ 





/** Cambio de tallas en la PDP y Filtro */


// Activa el género si entra en una ruta que tenga Mujer. 
window.addEventListener('DOMContentLoaded', () => {

  
  var control_assign_event = false;
  var url_control = window.location.href;

  let url = window.location.pathname;

  if(url.includes('/products')){

    let man_action = document.getElementById('mhu');
    let woman_action = document.getElementById('mmu');

    let man_menu = document.querySelector('.menu-hombre');  
    let woman_menu = document.querySelector('.menu-mujer');

    let selected_gender;

    // Hace click de acuerdo con la URL:
    if(man_action && woman_action){
      if(location.href.includes('mujer')){
        woman_action.click();
      }
    
      if(man_action.dataset.selectedGender === 'hombre') {
        selected_gender = 'hombre';
        // console.log('Tiene seleccionado el género hombre.');
      } else {
        selected_gender = 'mujer';
        // console.log('Tiene seleccionado el género mujer.');
      }
    } else {
      // console.log('No tiene ambos botones');
      if(man_menu){
        selected_gender = 'hombre';
      } else if(woman_menu){
        // console.log(woman_menu);
        selected_gender = 'mujer';
      }else {
        selected_gender = 'ninos';
      }
    } 


     // Se agregó para que no fuera por el click ALERTA
     localStorage.setItem('size_type', 'us');

    // Crea el elemento: 
    let size_content = document.querySelector('.container-info-tallas .titles-mains');
    let change_size_btn = document.getElementById('pdp-change-size');
    var size_type = localStorage.getItem('size_type');

    
   
  
    // console.log('SIZE_TYPE:', size_type);
    // localStorage.setItem('size_type', '');

    if(!size_type || size_type.value === null){
      localStorage.setItem('size_type', 'eu');
      size_type = localStorage.getItem('size_type');
    }

    // console.log('GET ITEM:');
    // console.log(localStorage.getItem('size_type'));

    
    if(size_content && change_size_btn === null){
      if(localStorage.getItem('size_type') === 'us'){
          // console.log('Talla para pasar a Europea');
          size_content.insertAdjacentHTML('beforeEnd', '<span id="pdp-change-size">Talla Americana</span>');
          size_content.display = 'block';
      } else {
          // console.log('Talla para pasar a Americana');
          size_content.insertAdjacentHTML('beforeEnd', '<span id="pdp-change-size">Talla Europea</span>');
          size_content.display = 'block';
      }     
    }

    // console.log('Size Type:');
    // console.log(size_type);

    if(size_type){
      let sizes_values = document.querySelectorAll('.container-info-tallas .content-tallas .container-item-talla .item-talla');
      if(size_type === 'eu'){
        document.getElementById('pdp-change-size').innerText = 'Talla Americana';           
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
      } else if (size_type === 'us') {
        // document.getElementById('pdp-change-size').innerText = 'Talla Europea'; 
        assignSizeValuesPDP(sizes_values, selected_gender, size_type);
      }

      let pdp_change_btn = document.getElementById('pdp-change-size');

      // console.log('PDP BTN:', pdp_change_btn);

      if(pdp_change_btn){
        // console.log('Asignando evento');
        pdp_change_btn.addEventListener('click', (event)=> {


          // console.log('SIZE TYPE: ', size_type.trim());

          // size_active = !size_active;

          if (size_type === 'eu') { 
            // console.log('SIZE TYPE EU: ', size_type.trim());
              document.getElementById('pdp-change-size').innerText = 'Talla Europea'; 
              localStorage.setItem('size_type', 'us');
              size_type = localStorage.getItem('size_type');
           } else { 
            // console.log('SIZE TYPE USA: ', size_type.trim());
              document.getElementById('pdp-change-size').innerText = 'Talla Americana'; 
              localStorage.setItem('size_type', 'eu'); 
              size_type = localStorage.getItem('size_type');
          }

          if(sizes_values){                    
            assignSizeValuesPDP(sizes_values, selected_gender, size_type);                  
          }
      

          // console.log('Click'); 
          event.preventDefault();
          event.stopPropagation();


        
        });
      }

      
    }    
  }


});


function assignSizeValuesPDP(sizes_values, selected_gender, size_type){

  // console.log('Valores de la talla: ', sizes_values);
  // console.log('Género seleecionado: ', selected_gender); 
  // console.log('Tipo de talla: ', size_type);

  // Configuración de Regex: 
  const regex_woman = /mujer/i,
      regex_man   = /hombre/i,
      regex_kids  = /ninos/i,
      regex_jb    = /jibbitz/i;

  if(regex_woman.test(selected_gender)){
      // console.log('Tiene tallas de mujer');


      sizes_values.forEach(e => {
          
          if(size_type === 'us'){
              switch (e.innerText){
                  case '33':  e.innerText = '3';  break;
                  case '34':  e.innerText = '4';  break;
                  case '35':  e.innerText = '5';  break;
                  case '36':  e.innerText = '6';  break;
                  case '37':  e.innerText = '7';  break;
                  case '38':  e.innerText = '8';  break;
                  case '39':  e.innerText = '9';  break;
                  case '40':  e.innerText = '10'; break;
                  case '41':  e.innerText = '11'; break;
                  case '42':  e.innerText = '12'; break;
              }           
          } else {
              switch (e.innerText){
                  case '3':   e.innerText = '33'; break;
                  case '4':   e.innerText = '34'; break;
                  case '5':   e.innerText = '35'; break;
                  case '6':   e.innerText = '36'; break;
                  case '7':   e.innerText = '37'; break;
                  case '8':   e.innerText = '38'; break;
                  case '9':   e.innerText = '39'; break;
                  case '10':  e.innerText = '40'; break;
                  case '11':  e.innerText = '41'; break;
                  case '12':  e.innerText = '42'; break;
              }   
          }

      });
  } else if(regex_man.test(selected_gender)){
      sizes_values.forEach(e => {
        if(size_type === 'us'){
              switch (e.innerText){
                  case '34':  e.innerText = '3';  break;
                  case '35':  e.innerText = '4';  break;
                  case '36':  e.innerText = '5';  break;
                  case '37':  e.innerText = '6';  break;
                  case '38':  e.innerText = '7';  break;
                  case '39':  e.innerText = '8';  break;
                  case '40':  e.innerText = '9';  break;
                  case '41':  e.innerText = '10'; break;
                  case '42':  e.innerText = '11'; break;
                  case '43':  e.innerText = '12'; break;
                  case '44':  e.innerText = '13'; break;
                  case '45':  e.innerText = '14'; break;
                  case '46':  e.innerText = '15'; break;
              }           
          } else {         
              switch (e.innerText){
                  case '3':   e.innerText = '34'; break;
                  case '4':   e.innerText = '35'; break;
                  case '5':   e.innerText = '36'; break;
                  case '6':   e.innerText = '37'; break;
                  case '7':   e.innerText = '38'; break;
                  case '8':   e.innerText = '39'; break;
                  case '9':   e.innerText = '40'; break;
                  case '10':  e.innerText = '41'; break;
                  case '11':  e.innerText = '42'; break;
                  case '12':  e.innerText = '43'; break;
                  case '13':  e.innerText = '44'; break;
                  case '14':  e.innerText = '45'; break;
                  case '15':  e.innerText = '46'; break;
              }   
          }
      });
  } else if(regex_kids.test(selected_gender)){
      sizes_values.forEach(e => {
          if(size_type === 'us'){
              switch (e.innerText){
                  case '21':  e.innerText = 'K3';  break;
                  case '22':  e.innerText = 'K4';  break;
                  case '23':  e.innerText = 'K5';  break;
                  case '24':  e.innerText = 'K6';  break;
                  case '25':  e.innerText = 'K7';  break;
                  case '26':  e.innerText = 'K8';  break;
                  case '27':  e.innerText = 'K9';  break;
                  case '28':  e.innerText = 'K10'; break;
                  case '29':  e.innerText = 'K11'; break;
                  case '30':  e.innerText = 'K12'; break;
                  case '31':  e.innerText = 'K13'; break;
                  case '32':  e.innerText = 'J1';  break;
                  case '33':  e.innerText = 'J2';  break;
                  case '34':  e.innerText = 'J3';  break;
                  case '35':  e.innerText = 'J4';  break;
                  case '36':  e.innerText = 'J5';  break;
                  case '37':  e.innerText = 'J6';  break;
              }           
          } else {
              switch (e.innerText){
                  case '3':  e.innerText = '21'; break;
                  case '4':  e.innerText = '22'; break;
                  case '5':  e.innerText = '23'; break;
                  case '6':  e.innerText = '24'; break;
                  case '7':  e.innerText = '25'; break;
                  case '8':  e.innerText = '26'; break;
                  case '9':  e.innerText = '27'; break;
                  case '10': e.innerText = '28'; break;
                  case '11': e.innerText = '29'; break;
                  case '12': e.innerText = '30'; break;
                  case '13': e.innerText = '31'; break;
                  case 'J1':  e.innerText = '32'; break;
                  case 'J2':  e.innerText = '33'; break;
                  case 'J3':  e.innerText = '34'; break;
                  case 'J4':  e.innerText = '35'; break;
                  case 'J5':  e.innerText = '36'; break;
                  case 'J6':  e.innerText = '37'; break;
              }   
          }
      });
  }  
}

// Drawer

// window.addEventListener('load', () => {
//   console.log('CARRITO CLEAR');

//   let sizes = document.querySelectorAll('#CartDrawer-CartItems .drawer__cart-items-wrapper .cart-items tbody[role=rowgroup] .cart-item .cart-item__details dl .product-option dd');
//   let size_type = localStorage.getItem('size_type');

//   sizes?.forEach(size => {
//     console.log('tallas carrito');
//     if(size_type === 'us'){

//       console.log('tallas carrito size type', size_type);

//       switch (size.innerHTML.trim()){
//           case 'H34':  size.innerHTML = 'M3';  break;
//           case 'H35':  size.innerHTML = 'M4';  break;
//           case 'H36':  size.innerHTML = 'M5';  break;
//           case 'H37':  size.innerHTML = 'M6';  break;
//           case 'H38':  size.innerHTML = 'M7';  break;
//           case 'H39':  size.innerHTML = 'M8';  break;
//           case 'H40':  size.innerHTML = 'M9';  break;
//           case 'H41':  size.innerHTML = 'M10'; break;
//           case 'H42':  size.innerHTML = 'M11'; break;
//           case 'H43':  size.innerHTML = 'M12'; break;
//           case 'H44':  size.innerHTML = 'M13'; break;
//           case 'H45':  size.innerHTML = 'M14'; break;

//           case 'M33':  size.innerHTML = 'W3';  break;
//           case 'M34':  size.innerHTML = 'W4';  break;
//           case 'M35':  size.innerHTML = 'W5';  break;
//           case 'M36':  size.innerHTML = 'W6';  break;
//           case 'M37':  size.innerHTML = 'W7';  break;
//           case 'M38':  size.innerHTML = 'W8';  break;
//           case 'M39':  size.innerHTML = 'W9';  break;
//           case 'M40':  size.innerHTML = 'W10'; break;
//           case 'M41':  size.innerHTML = 'W11'; break;
//           case 'M42':  size.innerHTML = 'W12'; break;

//           case 'H34-M35':  size.innerHTML = 'M3-W5';  break;
//           case 'H35-M36':  size.innerHTML = 'M4-W6';  break;
//           case 'H36-M37':  size.innerHTML = 'M5-W7';  break;
//           case 'H37-M38':  size.innerHTML = 'M6-W8';  break;
//           case 'H38-M39':  size.innerHTML = 'M7-W9';  break;
//           case 'H39-M40':  size.innerHTML = 'M8-W10';  break;
//           case 'H40-M41':  size.innerHTML = 'M9-W11';  break;
//           case 'M41-M42':  size.innerHTML = 'M10-W12'; break;


//           case 'K23':  size.innerHTML = 'C3'; break;

//           case 'K22':  size.innerHTML = 'C4';  break;
//           case 'K23':  size.innerHTML = 'C5';  break;
//           case 'K24':  size.innerHTML = 'C6';  break;
//           case 'K25':  size.innerHTML = 'C7';  break;
//           case 'K26':  size.innerHTML = 'C8';  break;
//           case 'K27':  size.innerHTML = 'C9';  break;
//           case 'K28':  size.innerHTML = 'C10'; break;
//           case 'K29':  size.innerHTML = 'C11'; break;
//           case 'K30':  size.innerHTML = 'C12'; break;
//           case 'K31':  size.innerHTML = 'C13'; break;

//           case 'J32':  size.innerHTML = 'J1'; break;
//           case 'J33':  size.innerHTML = 'J2'; break;
//           case 'J34':  size.innerHTML = 'J3'; break;
//           case 'J35':  size.innerHTML = 'J4'; break;
//           case 'J36':  size.innerHTML = 'J5'; break;
//           case 'J37':  size.innerHTML = 'J6'; break;


//       }           
//   } else {
//       switch (size.innerHTML.trim()){
//         case 'M3':  size.innerHTML = 'H34';  break;
//         case 'M4':  size.innerHTML = 'H35';  break;
//         case 'M5':  size.innerHTML = 'H36';  break;
//         case 'M6':  size.innerHTML = 'H37';  break;
//         case 'M7':  size.innerHTML = 'H38';  break;
//         case 'M8':  size.innerHTML = 'H39';  break;
//         case 'M9':  size.innerHTML = 'H40';  break;
//         case 'M10': size.innerHTML = 'H41'; break;
//         case 'M11': size.innerHTML = 'H42'; break;
//         case 'M12': size.innerHTML = 'H43'; break;
//         case 'M13': size.innerHTML = 'H44'; break;
//         case 'M14': size.innerHTML = 'H45'; break;
        
//         case 'W3':  size.innerHTML = 'M33';  break;
//         case 'W4':  size.innerHTML = 'M34';  break;
//         case 'W5':  size.innerHTML = 'M35';  break;
//         case 'W6':  size.innerHTML = 'M36';  break;
//         case 'W7':  size.innerHTML = 'M37';  break;
//         case 'W8':  size.innerHTML = 'M38';  break;
//         case 'W9':  size.innerHTML = 'M39';  break;
//         case 'W10': size.innerHTML = 'M40'; break;
//         case 'W11': size.innerHTML = 'M41'; break;
//         case 'W12': size.innerHTML = 'M42'; break;
        
//         case 'M3-W5':  size.innerHTML = 'H34-M35';  break;
//         case 'M4-W6':  size.innerHTML = 'H35-M36';  break;
//         case 'M5-W7':  size.innerHTML = 'H36-M37';  break;
//         case 'M6-W8':  size.innerHTML = 'H37-M38';  break;
//         case 'M7-W9':  size.innerHTML = 'H38-M39';  break;
//         case 'M8-W10': size.innerHTML = 'H39-M40';  break;
//         case 'M9-W11': size.innerHTML = 'H40-M41';  break;
//         case 'M10-W12': size.innerHTML = 'M41-M42'; break;
        
        
//         case 'C3': size.innerHTML = 'K23'; break;
        
//         case 'C4':  size.innerHTML = 'K22';  break;
//         case 'C5':  size.innerHTML = 'K23';  break;
//         case 'C6':  size.innerHTML = 'K24';  break;
//         case 'C7':  size.innerHTML = 'K25';  break;
//         case 'C8':  size.innerHTML = 'K26';  break;
//         case 'C9':  size.innerHTML = 'K27';  break;
//         case 'C10': size.innerHTML = 'K28'; break;
//         case 'C11': size.innerHTML = 'K29'; break;
//         case 'C12': size.innerHTML = 'K30'; break;
//         case 'C13': size.innerHTML = 'K31'; break;
        
//         case 'J1': size.innerHTML = 'J32'; break;
//         case 'J2': size.innerHTML = 'J33'; break;
//         case 'J3': size.innerHTML = 'J34'; break;
//         case 'J4': size.innerHTML = 'J35'; break;
//         case 'J5': size.innerHTML = 'J36'; break;
//         case 'J6': size.innerHTML = 'J37'; break;
        
//       }   
//   }

//     console.log(size.innerHTML.trim());
//   });

// });



/** Cambio de tallas en la PDP y Filtro */




// // Variantes del detalle del producto




// // Modificación de las Tallas:

// if (document.getElementById("generoTallaje").value === "NINOS") {
//   changeNameTallas("K");
//   changeNameTallas("J");
// }
// // Input hidden Hombre:
// if (document.getElementById("generoTallaje").value === "HOMBRE") {

//   console.log('Hombre');

//   let countItemEstructura = 0;

//   document.querySelectorAll(".input-talla").forEach(function (input) {
//     if (input.value.includes("M")) {
//       countItemEstructura += 1;
//     }
//   });

//   if (countItemEstructura === 0) {
//     document.querySelector(".menu-mujer").style.display = "none";
//     document.querySelector(".menu-hombre").style.display = "block";
//   }

//   changeNameTallas("H");

//   document.querySelector(".menu-hombre").style.boxShadow = "inset 0 -2px 0 0 #000";
// } else if (document.getElementById("generoTallaje").value === "MUJER") {

//   console.log('Mujer');

//   let countItemEstructura = 0;

//   document.querySelectorAll(".input-talla").forEach(function (input) {
//     if (input.value.charAt(0) === "H") {
//       countItemEstructura += 1;
//     }
//   });

//   if (countItemEstructura === 0) {
//     document.querySelector(".menu-hombre").style.display = "none";
//     document.querySelector(".menu-mujer").style.display = "block";
//   }

//   changeNameTallas("M");
//   document.querySelector(".menu-mujer").style.boxShadow = "inset 0 -2px 0 0 #000";


// } else { 
//   // Unisex
//   document.querySelectorAll(".input-talla").forEach(function (input) {

//     if (input.value.charAt(0) === "H") {
     
//       document.querySelector(".menu-mujer-unisex").style.display = "block";
//       document.querySelector(".menu-hombre-unisex").style.display = "block";
//       document.querySelector(".menu-hombre-unisex").style.boxShadow = "inset 0 -2px 0 0 #000";
//       document.querySelector(".menu-hombre-unisex").setAttribute("data-selected-gender", "hombre");
//       document.querySelector(".menu-mujer-unisex").setAttribute("data-selected-gender", "");

//       let arrayValues;
//       if (input.value.search("/") !== -1) { //Si la tiene.
//         arrayValues = input.value.toUpperCase().split("/");
//       } else {
//         arrayValues = input.value.toUpperCase().split("-");
//       }

//       console.log(arrayValues);

//       for (let index = 0; index < arrayValues.length; index++) {

//         console.log('Index: ', index);
//         let value = arrayValues[index];
//         if (value.charAt(0) == "H") {
//           // console.log(arrayValues[index]);
//             input.setAttribute("data-seleccionada", arrayValues[index]);

//             console.log( document.querySelectorAll(".item-talla"));
//             changeNameTallas("H");
//             // document.querySelectorAll(".item-talla")[index].textContent = arrayValues[index].replace("H", "");
//             // console.log(document.querySelectorAll(".item-talla")[index].textContent);
//         }
//       }
    

//       sortElementSelect('.content-tallas');

//     } else if (input.value.charAt(0) === "M") {
//       console.log((input.value.charAt(0)));
//       console.log('a');
//       let arrayValues;
//       if (input.value.search("/") !== -1) { //Si la tiene.
//         arrayValues = input.value.toUpperCase().split("/");
//       } else {
//         arrayValues = input.value.toUpperCase().split("-");
//       }

//       console.log('Mujer: ', arrayValues);

//       for (let index = 0; index < arrayValues.length; index++) {
//         let value = arrayValues[index];
//         if (value.charAt(0) == "M") {
//             input.setAttribute("data-seleccionada", arrayValues[index]);
//             changeNameTallas("M");
//             // document.querySelectorAll(".item-talla")[index].textContent = arrayValues[index].replace("M", "");
//         }
//       }

//       sortElementSelect('.content-tallas');
//     } else {
//       input.setAttribute("data-seleccionada", input.value);
//       changeNameTallas("");
//     }
//   });
// }

// if(document.querySelector(".menu-hombre")){
//   document.querySelector(".menu-hombre").addEventListener("click", function() {
//     changeNameTallas("H");
//     document.querySelector(".menu-hombre").style.boxShadow = "inset 0 -2px 0 0 #000";
//     document.querySelector(".menu-mujer").style.boxShadow = "none";
//   });
// }


// if(document.querySelector(".menu-mujer")){
//   document.querySelector(".menu-mujer").addEventListener("click", function() {
//     changeNameTallas("M");
//     document.querySelector(".menu-mujer").style.boxShadow = "inset 0 -2px 0 0 #000";
//     document.querySelector(".menu-hombre").style.boxShadow = "none";
//   });
// }

// if(document.querySelector(".menu-hombre-unisex")){
//   document.querySelector(".menu-hombre-unisex").addEventListener("click", function() {
//     changeNameTallas("H");
//     document.querySelectorAll(".input-talla").forEach(function(input) {
//         if (input.value.indexOf("H") === -1) {
//             input.parentElement.style.display = "none";
//         } else {
//             input.parentElement.style.display = "block";
//         }
//     });
//     document.querySelector(".menu-hombre-unisex").style.display = "block";
//     document.querySelector(".menu-hombre-unisex").style.boxShadow = "inset 0 -2px 0 0 #000";
//     document.querySelector(".menu-mujer-unisex").style.display = "block";
//     document.querySelector(".menu-mujer-unisex").style.boxShadow = "none";
//     document.querySelector(".menu-hombre-unisex").setAttribute("data-selected-gender", "hombre");
//     document.querySelector(".menu-mujer-unisex").setAttribute("data-selected-gender", "");
  
//     // let man_action = document.getElementById('mhu');
//     // let selected_gender;
  
//     // let size_type = localStorage.getItem('size_type');
  
//     // if (!size_type) {
//     //     localStorage.setItem('size_type', 'us');
//     // }
  
//     // if (man_action.dataset.selectedGender === 'hombre') {
//     //     selected_gender = 'hombre';
//     //     console.log('Tiene seleccionado el género hombre.');
//     // } else {
//     //     selected_gender = 'mujer';
//     //     console.log('Tiene seleccionado el género mujer.');
//     // }
  
//     // if (size_type) {
//     //     let sizes_values = document.querySelectorAll('.container-info-tallas .content-tallas .container-item-talla .item-talla');
//     //     if (size_type === 'eu') {
//     //         assignSizeValuesPDP(sizes_values, selected_gender, size_type);
//     //     } else if (size_type === 'us') {
//     //         assignSizeValuesPDP(sizes_values, selected_gender, size_type);
//     //     }
//     // }
//   });
// }



// if(document.querySelector(".menu-mujer-unisex")){
//   document.querySelector(".menu-mujer-unisex").addEventListener("click", function() {
//     changeNameTallas("M");
//     document.querySelectorAll(".input-talla").forEach(function(input) {
//         if (input.value.indexOf("M") === -1) {
//             input.parentElement.style.display = "none";
//         } else {
//             input.parentElement.style.display = "block";
//         }
//     });
//     document.querySelector(".menu-mujer-unisex").style.display = "block";
//     document.querySelector(".menu-mujer-unisex").style.boxShadow = "inset 0 -2px 0 0 #000";
//     document.querySelector(".menu-hombre-unisex").style.display = "block";
//     document.querySelector(".menu-hombre-unisex").style.boxShadow = "none";
  
//     document.querySelector(".menu-mujer-unisex").setAttribute("data-selected-gender", "mujer");
//     document.querySelector(".menu-hombre-unisex").setAttribute("data-selected-gender", "");
  
//     let man_action = document.getElementById('mhu');
//     let selected_gender;
//     let size_type = localStorage.getItem('size_type');
  
//     if (!size_type) {
//         localStorage.setItem('size_type', 'us');
//     }
  
//     if (man_action.dataset.selectedGender === 'hombre') {
//         selected_gender = 'hombre';
//         console.log('Tiene seleccionado el género hombre.');
//     } else {
//         selected_gender = 'mujer';
//         console.log('Tiene seleccionado el género mujer.');
//     }
  
//     if (size_type) {
//         let sizes_values = document.querySelectorAll('.container-info-tallas .content-tallas .container-item-talla .item-talla');
//         if (size_type === 'eu') {
//             assignSizeValuesPDP(sizes_values, selected_gender, size_type);
//         } else if (size_type === 'us') {
//             assignSizeValuesPDP(sizes_values, selected_gender, size_type);
//         }
//     }
//   });
// }

// // Tallas del carrito:

// if(document.querySelectorAll(".value-variant-talla")){
//   document.querySelectorAll(".value-variant-talla").forEach(function(element) {
//     let arrayValues;
//     if (element.getAttribute("data-val-talla").search("/") !== -1) { // Si tiene "/"
//         arrayValues = element.getAttribute("data-val-talla").trim().toUpperCase().split("/");
//     } else {
//         arrayValues = element.getAttribute("data-val-talla").trim().toUpperCase().split("-");
//     }
  
//     for (let index = 0; index < arrayValues.length; index++) {
//         let value = arrayValues[index];
//         if (value.charAt(0) === element.getAttribute("data-genero")) {
//             let parentElement = element.parentElement.parentElement;
//             let valueProperties = parentElement.querySelector(".value-properties-product");
//             let textToDisplay = valueProperties ? valueProperties.querySelector("dd").textContent : element.getAttribute("data-val-talla");
//             element.textContent = textToDisplay;
//         } else if (element.getAttribute("data-genero") === "unisex") {
//             let parentElement = element.parentElement.parentElement;
//             let valueProperties = parentElement.querySelector(".value-properties-product");
//             let firstChar = valueProperties ? valueProperties.querySelector("dd").textContent.charAt(0) : "";
//             if (firstChar === "H") {
//                 let textToDisplay = valueProperties ? valueProperties.querySelector("dd").textContent : element.getAttribute("data-val-talla");
//                 element.textContent = textToDisplay;
//             } else {
//                 let textToDisplay = valueProperties ? valueProperties.querySelector("dd").textContent : element.getAttribute("data-val-talla");
//                 element.textContent = textToDisplay;
//             }
//         } else {
//             let parentElement = element.parentElement.parentElement;
//             let valueProperties = parentElement.querySelector(".value-properties-product");
//             let textToDisplay = valueProperties ? valueProperties.querySelector("dd").textContent : element.getAttribute("data-val-talla");
//             element.textContent = textToDisplay;
//         }
//     }
//   });  
// }


// /*Cuando vienen sin el prefijo de sexo H o M*/

// if(document.querySelectorAll(".input-talla")){
//   document.querySelectorAll(".input-talla").forEach(function(input) {
//     input.addEventListener("click", function() {
//         if (input.value.indexOf("M") === -1 && input.value.indexOf("H") === -1) {
//             input.setAttribute("data-seleccionada", input.value);
//         } else {
//             if (document.querySelector(".menu-hombre-unisex") && document.querySelector(".menu-hombre-unisex").style.boxShadow.includes("inset 0 -2px 0 0 #000")) {
//                 input.setAttribute("data-seleccionada", input.value.split("-")[0]);
//             } else {
//                 input.setAttribute("data-seleccionada", input.value.split("-")[1]);
//             }
//         }
  
//         if (document.getElementById("generoTallaje").value === "MUJER") {
//             if (document.querySelector(".menu-hombre") && document.querySelector(".menu-hombre").style.boxShadow && document.querySelector(".menu-hombre").style.boxShadow.includes("inset 0 -2px 0 0 #000")) {
//                 input.setAttribute("data-seleccionada", input.value.split("-")[0]);
//             } else if (document.querySelector(".menu-mujer") && document.querySelector(".menu-mujer").style.boxShadow && document.querySelector(".menu-mujer").style.boxShadow.includes("inset 0 -2px 0 0 #000")) {
//                 input.setAttribute("data-seleccionada", input.value.split("-")[1]);
//             }
//         }
  
//         if (document.getElementById("generoTallaje").value === "HOMBRE") {
//             if (document.querySelector(".menu-hombre") && document.querySelector(".menu-hombre").style.boxShadow && document.querySelector(".menu-hombre").style.boxShadow.includes("inset 0 -2px 0 0 #000")) {
//                 input.setAttribute("data-seleccionada", input.value.split("-")[0]);
//             } else if (document.querySelector(".menu-mujer") && document.querySelector(".menu-mujer").style.boxShadow && document.querySelector(".menu-mujer").style.boxShadow.includes("inset 0 -2px 0 0 #000")) {
//                 input.setAttribute("data-seleccionada", input.value.split("-")[1]);
//             }
//         }
//     });
//   });
// }


// function changeNameTallas(type) {
//   document.querySelectorAll(".input-talla").forEach(function(input, i) {
//       let arrayValues;
//       if (input.value.search("/") !== -1) { // Si tiene "/"
//           arrayValues = input.value.trim().toUpperCase().split("/");
//       } else {
//           arrayValues = input.value.trim().toUpperCase().split("-");
//       }
//       for (let index = 0; index < arrayValues.length; index++) {
//           let value = arrayValues[index];
//           if (value.charAt(0) === type) {
//               input.setAttribute("data-seleccionada", arrayValues[index]);
//               document.querySelectorAll(".item-talla")[i].textContent = arrayValues[index].replace(type, "");
//           }
//       }
//   });

//   sortElementSelect('.content-tallas');
// }

// function sortElementSelect(idList) {
//   var myList = document.querySelector(idList);
//   var item = Array.from(myList.querySelectorAll('.container-item-talla'));

//   item.sort(function(a, b) {
//       var aText = a.children[1].innerText;
//       var bText = b.children[1].innerText;

//       if (aText < bText) {
//           return -1;
//       }
//       if (aText > bText) {
//           return 1;
//       }
//       return 0;
//   });

//   item.forEach(function(element) {
//       myList.appendChild(element);
//   });
// }

// /** Fin de Tallas **/ 


// (()=> {
//   const getCart = async () => {
//     const responseCart = await fetch("/cart.json");
//     return await responseCart.json();
//   }
  
//   const showCart = async () => {
//     const cartItems = await getCart();
//     console.log(cartItems);  // Ahora muestra el contenido del carrito correctamente

//     const drawerHeading = document.querySelector('.drawer__heading');
//     if(drawerHeading && cartItems){
//       const text = `${drawerHeading.innerHTML} (${cartItems.item_count})`; 

//       if(text && text != ""){
//         drawerHeading.innerText = text; 
//       }
//       console.log('Items', text);
      
//     }
//   }
  
//   showCart();  // Ejecuta la función para mostrar el carrito  
  
 
// })();

